/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  BodyExtractReceiptReceiptExtractPost,
  BodyUploadPdfReceiptPdfPost,
  BodyUploadReceiptUploadPost,
  ClaimReviewRequest,
  ErrorResponse,
  ExtractReceiptReceiptExtractPostParams,
  ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
  GetPdfPreviewReceiptPreviewGetParams,
  HTTPValidationError,
  PdfReceiptRead,
  ReceiptClaimCalculationCreate,
  ReceiptClaimCalculationRead,
  ReceiptClaimCreate,
  ReceiptClaimRead,
  ReceiptDetectionResponse,
  ReceiptRedactionRequest,
  ReceiptRedactionResponse,
  ReceiptUploadResponse,
  UploadPdfReceiptPdfPostParams,
  UploadReceiptUploadPostParams,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Upload a receipt image, or a PDF receipt's Selected Pages, and detect the receipt. Returns immediately with detection results. Subscribe to /extract/{extraction_id}/events for AI extraction results.
 * @summary Extract Receipt
 */
export const extractReceiptReceiptExtractPost = (
  bodyExtractReceiptReceiptExtractPost?: BodyType<BodyExtractReceiptReceiptExtractPost>,
  params?: ExtractReceiptReceiptExtractPostParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (
    bodyExtractReceiptReceiptExtractPost?.file !== undefined &&
    bodyExtractReceiptReceiptExtractPost.file !== null
  ) {
    formData.append(`file`, bodyExtractReceiptReceiptExtractPost.file);
  }
  if (
    bodyExtractReceiptReceiptExtractPost?.pdf_url !== undefined &&
    bodyExtractReceiptReceiptExtractPost.pdf_url !== null
  ) {
    formData.append(`pdf_url`, bodyExtractReceiptReceiptExtractPost.pdf_url);
  }
  if (
    bodyExtractReceiptReceiptExtractPost?.selected_pages !== undefined &&
    bodyExtractReceiptReceiptExtractPost.selected_pages !== null
  ) {
    bodyExtractReceiptReceiptExtractPost?.selected_pages.forEach((value) =>
      formData.append(`selected_pages`, value.toString())
    );
  }

  return nmibleInstanceV3<ReceiptDetectionResponse>(
    {
      url: `/receipt/extract`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      params,
      signal,
    },
    options
  );
};

export const getExtractReceiptReceiptExtractPostMutationKey = () =>
  ["extractReceiptReceiptExtractPost"] as const;

export const getExtractReceiptReceiptExtractPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractReceiptReceiptExtractPost>>,
    TError,
    ExtractReceiptReceiptExtractPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractReceiptReceiptExtractPost>>,
  TError,
  ExtractReceiptReceiptExtractPostMutationVariables,
  TContext
> => {
  const mutationKey = getExtractReceiptReceiptExtractPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractReceiptReceiptExtractPost>>,
    ExtractReceiptReceiptExtractPostMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return extractReceiptReceiptExtractPost(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractReceiptReceiptExtractPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractReceiptReceiptExtractPost>>
>;
export type ExtractReceiptReceiptExtractPostMutationBody =
  | BodyType<BodyExtractReceiptReceiptExtractPost>
  | undefined;
export type ExtractReceiptReceiptExtractPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface ExtractReceiptReceiptExtractPostMutationVariables {
  data?: BodyType<BodyExtractReceiptReceiptExtractPost>;
  params?: ExtractReceiptReceiptExtractPostParams;
}

/**
 * @summary Extract Receipt
 */
export const useExtractReceiptReceiptExtractPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractReceiptReceiptExtractPost>>,
      TError,
      ExtractReceiptReceiptExtractPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof extractReceiptReceiptExtractPost>>,
  TError,
  ExtractReceiptReceiptExtractPostMutationVariables,
  TContext
> => {
  return useMutation(
    getExtractReceiptReceiptExtractPostMutationOptions(options),
    queryClient
  );
};
/**
 * SSE endpoint to stream extraction progress and results
 * @summary Extraction Events
 */
export const extractionEventsReceiptExtractExtractionIdEventsGet = (
  extractionId: string,
  params?: ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    {
      url: `/receipt/extract/${extractionId}/events`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getExtractionEventsReceiptExtractExtractionIdEventsGetQueryKey = (
  extractionId: string,
  params?: ExtractionEventsReceiptExtractExtractionIdEventsGetParams
) => {
  return [
    `/receipt/extract/${extractionId}/events`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExtractionEventsReceiptExtractExtractionIdEventsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
    >,
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
  >(
    extractionId: string,
    params?: ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof extractionEventsReceiptExtractExtractionIdEventsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExtractionEventsReceiptExtractExtractionIdEventsGetQueryKey(
        extractionId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
      >
    > = ({ signal }) =>
      extractionEventsReceiptExtractExtractionIdEventsGet(
        extractionId,
        params,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: extractionId !== null && extractionId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ExtractionEventsReceiptExtractExtractionIdEventsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
    >
  >;
export type ExtractionEventsReceiptExtractExtractionIdEventsGetQueryError =
  ErrorType<ErrorResponse | HTTPValidationError>;

export function useExtractionEventsReceiptExtractExtractionIdEventsGet<
  TData = Awaited<
    ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  extractionId: string,
  params: undefined | ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof extractionEventsReceiptExtractExtractionIdEventsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof extractionEventsReceiptExtractExtractionIdEventsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExtractionEventsReceiptExtractExtractionIdEventsGet<
  TData = Awaited<
    ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  extractionId: string,
  params?: ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof extractionEventsReceiptExtractExtractionIdEventsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof extractionEventsReceiptExtractExtractionIdEventsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExtractionEventsReceiptExtractExtractionIdEventsGet<
  TData = Awaited<
    ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  extractionId: string,
  params?: ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Extraction Events
 */

export function useExtractionEventsReceiptExtractExtractionIdEventsGet<
  TData = Awaited<
    ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  extractionId: string,
  params?: ExtractionEventsReceiptExtractExtractionIdEventsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof extractionEventsReceiptExtractExtractionIdEventsGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExtractionEventsReceiptExtractExtractionIdEventsGetQueryOptions(
      extractionId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Calculate receipt claim total before submission.
 *
 * A participant calculates their own claim, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `body.participant_id`. A participant the User can't see, in another tenant or deleted is a 404 `COM-02`.
 *
 * For a User, the claim goes on the Participant Visit the site confirmed and takes its date. Without one, the visit `type` is required, as submit creates a Participant Visit confirmed by that User, else 422 `PVC-05`.
 *
 * `image_url` must be a key POST /receipt/upload or POST /receipt/extract returned for the claim's participant, the one a User names. Any other key, such as another participant's or another tenant's receipt, a link, or a PDF Receipt and its Page Previews, is refused with 404 `COM-02` before anything else is checked.
 *
 * Refused with 422 `PMT-05` when the participant's current Default Payment Account cannot receive receipt claims (for example a Stripe Stipend Card); another payment method must be chosen.
 *
 * Refused with 422 `CLM-05` when the total, the items plus tax and fees less any discount, comes to 0 or less once rounded down for the claim currency.
 *
 * Refused with a 422 validation error when `image_url` is missing, empty or only spaces, or `currency` is longer than 3 letters.
 * @summary Calculate Claim
 */
export const calculateClaimReceiptCalculatePost = (
  receiptClaimCalculationCreate: BodyType<ReceiptClaimCalculationCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ReceiptClaimCalculationRead>(
    {
      url: `/receipt/calculate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: receiptClaimCalculationCreate,
      signal,
    },
    options
  );
};

export const getCalculateClaimReceiptCalculatePostMutationKey = () =>
  ["calculateClaimReceiptCalculatePost"] as const;

export const getCalculateClaimReceiptCalculatePostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof calculateClaimReceiptCalculatePost>>,
    TError,
    CalculateClaimReceiptCalculatePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof calculateClaimReceiptCalculatePost>>,
  TError,
  CalculateClaimReceiptCalculatePostMutationVariables,
  TContext
> => {
  const mutationKey = getCalculateClaimReceiptCalculatePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof calculateClaimReceiptCalculatePost>>,
    CalculateClaimReceiptCalculatePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return calculateClaimReceiptCalculatePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CalculateClaimReceiptCalculatePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof calculateClaimReceiptCalculatePost>>
>;
export type CalculateClaimReceiptCalculatePostMutationBody =
  BodyType<ReceiptClaimCalculationCreate>;
export type CalculateClaimReceiptCalculatePostMutationError =
  ErrorType<ErrorResponse>;
export interface CalculateClaimReceiptCalculatePostMutationVariables {
  data: BodyType<ReceiptClaimCalculationCreate>;
}

/**
 * @summary Calculate Claim
 */
export const useCalculateClaimReceiptCalculatePost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof calculateClaimReceiptCalculatePost>>,
      TError,
      CalculateClaimReceiptCalculatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof calculateClaimReceiptCalculatePost>>,
  TError,
  CalculateClaimReceiptCalculatePostMutationVariables,
  TContext
> => {
  return useMutation(
    getCalculateClaimReceiptCalculatePostMutationOptions(options),
    queryClient
  );
};
/**
 * Submit a receipt claim for reimbursement.
 *
 * A participant raises their own claim, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `body.participant_id`. A participant the User can't see, in another tenant or deleted is a 404 `COM-02`. The claim records who raised it in `created_by_participant_id` or `created_by_user_id`.
 *
 * For a User, the claim goes on the Participant Visit the site confirmed and takes its date. Without one, a Participant Visit confirmed by that User is created, which needs the visit `type`, else 422 `PVC-05`.
 *
 * `image_url` must be a key POST /receipt/upload or POST /receipt/extract returned for the claim's participant, the one a User names. Any other key, such as another participant's or another tenant's receipt, a link, or a PDF Receipt and its Page Previews, is refused with 404 `COM-02` before anything else is checked, and no claim or participant visit is created.
 *
 * An `extraction_id` links the claim to that Receipt Extraction only when it belongs to the claim's participant, otherwise it is dropped.
 *
 * Refused with 422 `PMT-05` when the participant's current Default Payment Account cannot receive receipt claims (for example a Stripe Stipend Card); another payment method must be chosen.
 *
 * Refused with 422 `CLM-05` when the total, the items plus tax and fees less any discount, comes to 0 or less once rounded down for the claim currency, and no claim or participant visit is created.
 *
 * Refused with a 422 validation error when `image_url` is missing, empty or only spaces, or `currency` is longer than 3 letters, and no claim is created.
 * @summary Submit Claim
 */
export const submitClaimReceiptPost = (
  receiptClaimCreate: BodyType<ReceiptClaimCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ReceiptClaimRead>(
    {
      url: `/receipt`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: receiptClaimCreate,
      signal,
    },
    options
  );
};

export const getSubmitClaimReceiptPostMutationKey = () =>
  ["submitClaimReceiptPost"] as const;

export const getSubmitClaimReceiptPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitClaimReceiptPost>>,
    TError,
    SubmitClaimReceiptPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitClaimReceiptPost>>,
  TError,
  SubmitClaimReceiptPostMutationVariables,
  TContext
> => {
  const mutationKey = getSubmitClaimReceiptPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitClaimReceiptPost>>,
    SubmitClaimReceiptPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return submitClaimReceiptPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitClaimReceiptPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitClaimReceiptPost>>
>;
export type SubmitClaimReceiptPostMutationBody = BodyType<ReceiptClaimCreate>;
export type SubmitClaimReceiptPostMutationError = ErrorType<ErrorResponse>;
export interface SubmitClaimReceiptPostMutationVariables {
  data: BodyType<ReceiptClaimCreate>;
}

/**
 * @summary Submit Claim
 */
export const useSubmitClaimReceiptPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitClaimReceiptPost>>,
      TError,
      SubmitClaimReceiptPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitClaimReceiptPost>>,
  TError,
  SubmitClaimReceiptPostMutationVariables,
  TContext
> => {
  return useMutation(
    getSubmitClaimReceiptPostMutationOptions(options),
    queryClient
  );
};
/**
 * Get the Page Previews of a PDF Receipt the participant uploaded, with fresh links, to pick its pages again.
 *
 * The body is the one POST /receipt/pdf returned for the PDF, with each JPEG Page Preview signed again for an hour and `max_selected_pages` the limit in force now, not the one at upload. Only the stored Page Previews are read, never the PDF, and no field links to the PDF.
 *
 * A participant reads their own, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `query.participant_id`. A participant the User can't see, in another tenant or deleted is a 404 `COM-02`. Not gated on receipt AI. Without a token it is a 401 `ATH-04`, and a User without Claims Create is a 403 `ATH-05`. Leaving out `pdf_url` is a 422 validation error on `query.pdf_url`.
 *
 * Refused with 404 `COM-02`, before anything is read, when `pdf_url` isn't a PDF in the participant's own receipts, such as another participant's or another tenant's PDF or an image. Also 404 `COM-02` until every Page Preview of the PDF is stored.
 *
 * Rate limited per caller at the INTENSIVE tier.
 * @summary Get a PDF receipt's Page Previews again
 */
export const getPdfPreviewReceiptPreviewGet = (
  params: GetPdfPreviewReceiptPreviewGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<PdfReceiptRead>(
    { url: `/receipt/preview`, method: "GET", params, signal },
    options
  );
};

export const getGetPdfPreviewReceiptPreviewGetQueryKey = (
  params?: GetPdfPreviewReceiptPreviewGetParams
) => {
  return [`/receipt/preview`, ...(params ? [params] : [])] as const;
};

export const getGetPdfPreviewReceiptPreviewGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: GetPdfPreviewReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPdfPreviewReceiptPreviewGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>
  > = ({ signal }) =>
    getPdfPreviewReceiptPreviewGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPdfPreviewReceiptPreviewGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>
>;
export type GetPdfPreviewReceiptPreviewGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetPdfPreviewReceiptPreviewGet<
  TData = Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: GetPdfPreviewReceiptPreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
          TError,
          Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPdfPreviewReceiptPreviewGet<
  TData = Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: GetPdfPreviewReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
          TError,
          Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPdfPreviewReceiptPreviewGet<
  TData = Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: GetPdfPreviewReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a PDF receipt's Page Previews again
 */

export function useGetPdfPreviewReceiptPreviewGet<
  TData = Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: GetPdfPreviewReceiptPreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPdfPreviewReceiptPreviewGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPdfPreviewReceiptPreviewGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get receipt claim by ID
 *
 * A participant gets `created_by_user_id`, `created_by_user` and
 * `details.reviewed_by` as null.
 * A User gets `allowed_actions`, what they can do to the claim now.
 * @summary Get Claim
 */
export const getClaimReceiptClaimIdGet = (
  claimId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ReceiptClaimRead>(
    { url: `/receipt/${claimId}`, method: "GET", signal },
    options
  );
};

export const getGetClaimReceiptClaimIdGetQueryKey = (claimId: string) => {
  return [`/receipt/${claimId}`] as const;
};

export const getGetClaimReceiptClaimIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClaimReceiptClaimIdGetQueryKey(claimId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>
  > = ({ signal }) =>
    getClaimReceiptClaimIdGet(claimId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: claimId !== null && claimId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClaimReceiptClaimIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>
>;
export type GetClaimReceiptClaimIdGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetClaimReceiptClaimIdGet<
  TData = Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
          TError,
          Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClaimReceiptClaimIdGet<
  TData = Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
          TError,
          Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClaimReceiptClaimIdGet<
  TData = Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Claim
 */

export function useGetClaimReceiptClaimIdGet<
  TData = Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  claimId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClaimReceiptClaimIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClaimReceiptClaimIdGetQueryOptions(
    claimId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Review (approve or reject) a participant receipt claim.
 *
 * Approval is refused with 422 `PMT-05`, before any payout is created, when
 * the participant's current Default Payment Account cannot receive receipt
 * claims (for example a Stripe Stipend Card). PPS pays that account, so a
 * claim reimbursement must never be routed to it.
 *
 * Approving stores the Approved Amount that PASS pays in `approved_amount`.
 * It is the Claimed Amount in `amount` unless `approved_amount` is sent, which
 * makes an Amount Adjustment. The claim is then approved and paid at that lower
 * amount, and `amount` keeps the Claimed Amount. `external_notes` is required as
 * the reason for the participant. An amount at or above the Claimed Amount is
 * refused with 422 `CLM-04` before any payout is created. Rejecting leaves
 * `approved_amount` null. The receipt `details` and items stay as submitted.
 *
 * While Claim Peer Review is on, the User who raised the claim cannot approve
 * it, with or without an Amount Adjustment, and gets 400 `APR-02` before any
 * payout is created. They can still reject it.
 * @summary Review Claim
 */
export const reviewClaimReceiptReceiptIdReviewPost = (
  receiptId: string,
  claimReviewRequest: BodyType<ClaimReviewRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ReceiptClaimRead>(
    {
      url: `/receipt/${receiptId}/review`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: claimReviewRequest,
      signal,
    },
    options
  );
};

export const getReviewClaimReceiptReceiptIdReviewPostMutationKey = () =>
  ["reviewClaimReceiptReceiptIdReviewPost"] as const;

export const getReviewClaimReceiptReceiptIdReviewPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewClaimReceiptReceiptIdReviewPost>>,
    TError,
    ReviewClaimReceiptReceiptIdReviewPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviewClaimReceiptReceiptIdReviewPost>>,
  TError,
  ReviewClaimReceiptReceiptIdReviewPostMutationVariables,
  TContext
> => {
  const mutationKey = getReviewClaimReceiptReceiptIdReviewPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviewClaimReceiptReceiptIdReviewPost>>,
    ReviewClaimReceiptReceiptIdReviewPostMutationVariables
  > = (props) => {
    const { receiptId, data } = props ?? {};

    return reviewClaimReceiptReceiptIdReviewPost(
      receiptId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewClaimReceiptReceiptIdReviewPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof reviewClaimReceiptReceiptIdReviewPost>>
>;
export type ReviewClaimReceiptReceiptIdReviewPostMutationBody =
  BodyType<ClaimReviewRequest>;
export type ReviewClaimReceiptReceiptIdReviewPostMutationError =
  ErrorType<ErrorResponse>;
export interface ReviewClaimReceiptReceiptIdReviewPostMutationVariables {
  receiptId: string;
  data: BodyType<ClaimReviewRequest>;
}

/**
 * @summary Review Claim
 */
export const useReviewClaimReceiptReceiptIdReviewPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reviewClaimReceiptReceiptIdReviewPost>>,
      TError,
      ReviewClaimReceiptReceiptIdReviewPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof reviewClaimReceiptReceiptIdReviewPost>>,
  TError,
  ReviewClaimReceiptReceiptIdReviewPostMutationVariables,
  TContext
> => {
  return useMutation(
    getReviewClaimReceiptReceiptIdReviewPostMutationOptions(options),
    queryClient
  );
};
/**
 * Black out one or more areas of a receipt image and attach the redacted result to the claim. Used when PII such as a participant's name is still visible on the stored receipt. Regions are polygons with coordinates normalized 0-1000. The redacted image is stored as a new object and the previous one is retained, so the endpoint can be called repeatedly to cover more of the image. Works at any claim status, including approved and paid.
 * @summary Redact areas of a receipt image
 */
export const redactReceiptReceiptReceiptClaimIdRedactPost = (
  receiptClaimId: string,
  receiptRedactionRequest: BodyType<ReceiptRedactionRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ReceiptRedactionResponse>(
    {
      url: `/receipt/${receiptClaimId}/redact`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: receiptRedactionRequest,
      signal,
    },
    options
  );
};

export const getRedactReceiptReceiptReceiptClaimIdRedactPostMutationKey = () =>
  ["redactReceiptReceiptReceiptClaimIdRedactPost"] as const;

export const getRedactReceiptReceiptReceiptClaimIdRedactPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redactReceiptReceiptReceiptClaimIdRedactPost>>,
    TError,
    RedactReceiptReceiptReceiptClaimIdRedactPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redactReceiptReceiptReceiptClaimIdRedactPost>>,
  TError,
  RedactReceiptReceiptReceiptClaimIdRedactPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getRedactReceiptReceiptReceiptClaimIdRedactPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redactReceiptReceiptReceiptClaimIdRedactPost>>,
    RedactReceiptReceiptReceiptClaimIdRedactPostMutationVariables
  > = (props) => {
    const { receiptClaimId, data } = props ?? {};

    return redactReceiptReceiptReceiptClaimIdRedactPost(
      receiptClaimId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RedactReceiptReceiptReceiptClaimIdRedactPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof redactReceiptReceiptReceiptClaimIdRedactPost>>
  >;
export type RedactReceiptReceiptReceiptClaimIdRedactPostMutationBody =
  BodyType<ReceiptRedactionRequest>;
export type RedactReceiptReceiptReceiptClaimIdRedactPostMutationError =
  ErrorType<ErrorResponse>;
export interface RedactReceiptReceiptReceiptClaimIdRedactPostMutationVariables {
  receiptClaimId: string;
  data: BodyType<ReceiptRedactionRequest>;
}

/**
 * @summary Redact areas of a receipt image
 */
export const useRedactReceiptReceiptReceiptClaimIdRedactPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof redactReceiptReceiptReceiptClaimIdRedactPost>>,
      TError,
      RedactReceiptReceiptReceiptClaimIdRedactPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof redactReceiptReceiptReceiptClaimIdRedactPost>>,
  TError,
  RedactReceiptReceiptReceiptClaimIdRedactPostMutationVariables,
  TContext
> => {
  return useMutation(
    getRedactReceiptReceiptReceiptClaimIdRedactPostMutationOptions(options),
    queryClient
  );
};
/**
 * Upload a receipt to the participant's receipts, an image as `file` or a PDF Receipt's Selected Pages as `pdf_url` and `selected_pages`.
 *
 * An image is PNG, JPEG, JPG or GIF, up to 10 MB, and is stored as sent.
 *
 * For a PDF Receipt, `pdf_url` is the one POST /receipt/pdf returned and `selected_pages` the pages to keep. The receipt is drawn from those pages, top to bottom in PDF order, as one JPEG in the participant's `receipts/original/`, so the same pages in any order give the same `file_url`. The drawn receipt isn't refused for its size, and drawing isn't gated on receipt AI.
 *
 * A participant uploads for themselves, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `query.participant_id`. A participant the User can't see, in another tenant or deleted is a 404 `COM-02`, and nothing is stored.
 *
 * Send `file`, or `pdf_url` with `selected_pages`, else it is a 422 validation error. Neither is `missing` on `body.file`, both is a `value_error` on `body.pdf_url`, `selected_pages` without `pdf_url` is `missing` on `body.pdf_url`, and `pdf_url` without `selected_pages` is `missing` on `body.selected_pages`. A repeated page is a `value_error` on `body.selected_pages`, and a page below 1 a `greater_than_equal` at its place in `body.selected_pages`.
 *
 * Refused with 400 `COM-01`, and nothing is stored, when the image's type is not supported or it is over 10 MB, when more pages are selected than POST /receipt/pdf's `max_selected_pages` or a page is past the end of the PDF, or when the pages can't be drawn in time.
 *
 * Refused with 404 `COM-02`, and nothing is stored, when `pdf_url` isn't a PDF in the participant's own receipts, such as another participant's or another tenant's PDF, before anything is read, or when it has no stored Page Previews.
 *
 * Rate limited per caller at the STANDARD tier, a participant or User alike.
 * @summary Upload a receipt image or a PDF receipt's Selected Pages
 */
export const uploadReceiptUploadPost = (
  bodyUploadReceiptUploadPost?: BodyType<BodyUploadReceiptUploadPost>,
  params?: UploadReceiptUploadPostParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (
    bodyUploadReceiptUploadPost?.file !== undefined &&
    bodyUploadReceiptUploadPost.file !== null
  ) {
    formData.append(`file`, bodyUploadReceiptUploadPost.file);
  }
  if (
    bodyUploadReceiptUploadPost?.pdf_url !== undefined &&
    bodyUploadReceiptUploadPost.pdf_url !== null
  ) {
    formData.append(`pdf_url`, bodyUploadReceiptUploadPost.pdf_url);
  }
  if (
    bodyUploadReceiptUploadPost?.selected_pages !== undefined &&
    bodyUploadReceiptUploadPost.selected_pages !== null
  ) {
    bodyUploadReceiptUploadPost?.selected_pages.forEach((value) =>
      formData.append(`selected_pages`, value.toString())
    );
  }

  return nmibleInstanceV3<ReceiptUploadResponse>(
    {
      url: `/receipt/upload`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      params,
      signal,
    },
    options
  );
};

export const getUploadReceiptUploadPostMutationKey = () =>
  ["uploadReceiptUploadPost"] as const;

export const getUploadReceiptUploadPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadReceiptUploadPost>>,
    TError,
    UploadReceiptUploadPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadReceiptUploadPost>>,
  TError,
  UploadReceiptUploadPostMutationVariables,
  TContext
> => {
  const mutationKey = getUploadReceiptUploadPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadReceiptUploadPost>>,
    UploadReceiptUploadPostMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return uploadReceiptUploadPost(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadReceiptUploadPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadReceiptUploadPost>>
>;
export type UploadReceiptUploadPostMutationBody =
  | BodyType<BodyUploadReceiptUploadPost>
  | undefined;
export type UploadReceiptUploadPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface UploadReceiptUploadPostMutationVariables {
  data?: BodyType<BodyUploadReceiptUploadPost>;
  params?: UploadReceiptUploadPostParams;
}

/**
 * @summary Upload a receipt image or a PDF receipt's Selected Pages
 */
export const useUploadReceiptUploadPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadReceiptUploadPost>>,
      TError,
      UploadReceiptUploadPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof uploadReceiptUploadPost>>,
  TError,
  UploadReceiptUploadPostMutationVariables,
  TContext
> => {
  return useMutation(
    getUploadReceiptUploadPostMutationOptions(options),
    queryClient
  );
};
/**
 * Upload a PDF Receipt to the participant's receipts and get a Page Preview of each page, to pick the pages of the receipt.
 *
 * `pdf_url` is the PDF's storage key, sent back with the Selected Pages, and no field links to the PDF. `pages` holds every page in PDF order, each with a JPEG Page Preview signed for an hour and its size in pixels. `max_selected_pages` is the most pages that can be selected.
 *
 * Each page is drawn once. Uploading the same PDF again returns the same `pdf_url` and the stored Page Previews with fresh links, so a retry is safe.
 *
 * A participant uploads for themselves, and a `participant_id` they send is ignored. A User with Claims Create names the participant with `participant_id`, and leaving it out is a 422 validation error on `query.participant_id`. A participant the User can't see, in another tenant or deleted is a 404 `COM-02`, and nothing is stored. Not gated on receipt AI. Without a token it is a 401 `ATH-04`, and a User without Claims Create is a 403 `ATH-05`.
 *
 * Refused with 400 `COM-01` when the file is not `application/pdf`, is over 10 MB, its content doesn't start as a PDF, or the PDF can't be opened or drawn in time, and nothing is stored.
 *
 * A PDF that needs a password to open is refused with 422 `RCT-03`, and nothing is stored. A PDF with only an owner password opens without one, so it is accepted.
 *
 * A PDF with more pages than the page limit, 20 by default, is refused with 422 `RCT-04` naming the limit, before any page is drawn, and nothing is stored. A PDF uploaded before is checked against the current limit.
 *
 * Rate limited per caller at the STANDARD tier.
 * @summary Upload a PDF receipt and get its Page Previews
 */
export const uploadPdfReceiptPdfPost = (
  bodyUploadPdfReceiptPdfPost: BodyType<BodyUploadPdfReceiptPdfPost>,
  params?: UploadPdfReceiptPdfPostParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadPdfReceiptPdfPost.file);

  return nmibleInstanceV3<PdfReceiptRead>(
    {
      url: `/receipt/pdf`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      params,
      signal,
    },
    options
  );
};

export const getUploadPdfReceiptPdfPostMutationKey = () =>
  ["uploadPdfReceiptPdfPost"] as const;

export const getUploadPdfReceiptPdfPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPdfReceiptPdfPost>>,
    TError,
    UploadPdfReceiptPdfPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadPdfReceiptPdfPost>>,
  TError,
  UploadPdfReceiptPdfPostMutationVariables,
  TContext
> => {
  const mutationKey = getUploadPdfReceiptPdfPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPdfReceiptPdfPost>>,
    UploadPdfReceiptPdfPostMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return uploadPdfReceiptPdfPost(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPdfReceiptPdfPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPdfReceiptPdfPost>>
>;
export type UploadPdfReceiptPdfPostMutationBody =
  BodyType<BodyUploadPdfReceiptPdfPost>;
export type UploadPdfReceiptPdfPostMutationError = ErrorType<ErrorResponse>;
export interface UploadPdfReceiptPdfPostMutationVariables {
  data: BodyType<BodyUploadPdfReceiptPdfPost>;
  params?: UploadPdfReceiptPdfPostParams;
}

/**
 * @summary Upload a PDF receipt and get its Page Previews
 */
export const useUploadPdfReceiptPdfPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadPdfReceiptPdfPost>>,
      TError,
      UploadPdfReceiptPdfPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof uploadPdfReceiptPdfPost>>,
  TError,
  UploadPdfReceiptPdfPostMutationVariables,
  TContext
> => {
  return useMutation(
    getUploadPdfReceiptPdfPostMutationOptions(options),
    queryClient
  );
};
/**
 * Cancel a pending receipt claim, so it won't be paid.
 *
 * A participant cancels a claim they raised. A User with Claims Update cancels a claim a User raised for a participant, whichever User raised it. A User cancelling a claim the participant raised, or a participant cancelling a claim a User raised, is a 403 `ATH-05` and the claim stays pending. A User without Claims Update is a 403 `ATH-05`. A claim the User can't see or in another tenant is a 404 `COM-02`.
 *
 * Refused with 409 `CLM-03` when the claim is no longer pending, whoever cancels it.
 * @summary Cancel
 */
export const cancelReceiptReceiptClaimIdDelete = (
  receiptClaimId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/receipt/${receiptClaimId}`, method: "DELETE", signal },
    options
  );
};

export const getCancelReceiptReceiptClaimIdDeleteMutationKey = () =>
  ["cancelReceiptReceiptClaimIdDelete"] as const;

export const getCancelReceiptReceiptClaimIdDeleteMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelReceiptReceiptClaimIdDelete>>,
    TError,
    CancelReceiptReceiptClaimIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelReceiptReceiptClaimIdDelete>>,
  TError,
  CancelReceiptReceiptClaimIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getCancelReceiptReceiptClaimIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelReceiptReceiptClaimIdDelete>>,
    CancelReceiptReceiptClaimIdDeleteMutationVariables
  > = (props) => {
    const { receiptClaimId } = props ?? {};

    return cancelReceiptReceiptClaimIdDelete(receiptClaimId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelReceiptReceiptClaimIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelReceiptReceiptClaimIdDelete>>
>;

export type CancelReceiptReceiptClaimIdDeleteMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface CancelReceiptReceiptClaimIdDeleteMutationVariables {
  receiptClaimId: string;
}

/**
 * @summary Cancel
 */
export const useCancelReceiptReceiptClaimIdDelete = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelReceiptReceiptClaimIdDelete>>,
      TError,
      CancelReceiptReceiptClaimIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cancelReceiptReceiptClaimIdDelete>>,
  TError,
  CancelReceiptReceiptClaimIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getCancelReceiptReceiptClaimIdDeleteMutationOptions(options),
    queryClient
  );
};
